import { Pagination, Reports } from '@factorin/domain';

import { withUrl, list, post, Request } from '../rest';


type CreateReport = {
    ReportTypeCode: string;
    ReportSettings: Reports.ReportSetting[];
}

const reportsPart = withUrl('reports');

export const reports = {
    ...list<Reports.BappReport, Pagination.Request>(reportsPart()),

    create: post<Request.Body<CreateReport>, void>(
        ({ body }) => reportsPart({
            body,
        }),
    ),
};
